import { FC } from "react";
import { SettingPageWrapper } from "@connectedComponents";
import { NavigationPathsEnum } from "@utilities/enums";
import { useControllers } from "./useControllers";

export const GeneralSettings:FC = ()=> {

    const { terms } = useControllers();

    return (
            <SettingPageWrapper
                activeTab={NavigationPathsEnum.SETTINGS}
            >
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-10 m-4">
                    <div className="prose prose-slate dark:prose-invert max-w-none">
                        <div 
                            className="text-gray-700 dark:text-gray-200 leading-relaxed whitespace-pre-line text-xs"
                            dangerouslySetInnerHTML={{ __html: terms }} 
                        />
                    </div>
                </div>
            </SettingPageWrapper>
    )
}
